import { Button, Col, message, Row } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import config from '../config';
import { revisionService } from '../services/revisionPage';
import EditAnswer from './components/EditAnswer';

const TestRevisionPage = () => {
  const [loading, setLoading] = useState(false);
  const [questionAnswers, setQuestionAnswers] = useState([]);
  const [newQuestionAnswers = [], setNewQuestionAnswers] = useState();
  const [disabledButton, setDisabledButton] = useState();

  const { id } = useParams();

  const validateSite = () => {
    return document.referrer.includes(config.redirectedFromSage);
  }

  const getQuestionsAnswers = async () => {
    try {
      setLoading(true);
      const response = await revisionService.getQuestionsAnswers({ 'idAdmissionPatientExam': id });
      if (response && response.length > 0) {
        let answerMaped = [];
        response.map((responseData) => {
          let answer = {
            "id": responseData.id,
            "admissionPatientExam": responseData.admission_patient_exam_id,
            "questionId": responseData.questionid,
            "questionTitle": responseData.name,
            "questionOptions": responseData && responseData.option && responseData.option.options,
            "selectedAnswer": responseData.result,
            "isChecking": true,
            "input_type": responseData.input_type,
            "groupId": responseData.groupid,
            "groupName": responseData.groupname,
            "order": responseData.order
          };
          answerMaped.push(answer);
        });

        setQuestionAnswers(answerMaped)
      } else {
        message.error({
          content: 'No se ha respondido esta encuesta.',
          className: 'psychology-message'
        });
      }
      setLoading(false);
    } catch (err) {
      console.error(err);
      message.error({
        content: 'Ocurrió un error. Inténtalo de nuevo.',
        className: 'psychology-message'
      });
      setLoading(false);
    }
  };

  const onEdit = useCallback(
    (id, answer) => {
      let editedAnswers = newQuestionAnswers;
      if (editedAnswers.some(edited => edited.questionId === id)) {
        for (let edited of editedAnswers) {
          if (id === edited.questionId) {
            edited.answer = answer;
          }
        }
      } else {
        questionAnswers.map((questionAnswer, index) => {
          if (id === questionAnswer.questionId) {
            const newAnswer = {
              "id": questionAnswer.id,
              "admissionPatientExam": questionAnswer.admissionPatientExam,
              "groupId": questionAnswer.groupId,
              "groupName": questionAnswer.groupName,
              "questionId": questionAnswer.questionId,
              "questionTitle": questionAnswer.questionTitle,
              "answer": answer,
              "questionOptions": questionAnswer.questionOptions,
              "order": questionAnswer.order
            }
            editedAnswers.push(newAnswer);
          }
        });
      }
      setDisabledButton(editedAnswers && editedAnswers.length > 0)
      setNewQuestionAnswers(editedAnswers);
    }, [newQuestionAnswers]
  );

  const mapQuestions = () => {
    let mappingResult = newQuestionAnswers;
    for (let questionAnswer of questionAnswers) {
      if (newQuestionAnswers && newQuestionAnswers.length > 0 && !newQuestionAnswers.some(result => result.questionId === questionAnswer.questionId)) {
        mappingResult.push({
          "id": questionAnswer.id,
          "admissionPatientExam": questionAnswer.admissionPatientExam,
          "groupId": questionAnswer.groupId,
          "groupName": questionAnswer.groupName,
          "questionId": questionAnswer.questionId,
          "questionTitle": questionAnswer.questionTitle,
          "answer": questionAnswer.selectedAnswer,
          "questionOptions": questionAnswer.questionOptions
        })
      } else if (!newQuestionAnswers || newQuestionAnswers.length === 0) {
        mappingResult.push({
          "id": questionAnswer.id,
          "admissionPatientExam": questionAnswer.admissionPatientExam,
          "groupId": questionAnswer.groupId,
          "groupName": questionAnswer.groupName,
          "questionId": questionAnswer.questionId,
          "questionTitle": questionAnswer.questionTitle,
          "answer": questionAnswer.selectedAnswer,
          "questionOptions": questionAnswer.questionOptions
        })
      }
    }
    return {
      tests_results: mappingResult,
      admissionPatientExam: newQuestionAnswers[0].admissionPatientExam
    };
  }

  const updateAnswer = async () => {
    setLoading(true);
    try {
      const questionsResponse = await revisionService.updateQuestionsAnswers({
        tests_results: newQuestionAnswers,
        admissionPatientExam: newQuestionAnswers[0].admissionPatientExam
      })
      if (questionsResponse && questionsResponse.length > 0 && !questionsResponse.some(result => result < 1)) {
        const procedureResponse = await revisionService.updateProcedureResults(mapQuestions())
        if (procedureResponse && procedureResponse.length > 0
          && procedureResponse.some(result => !result.some(res => res < 1))) {
          message.success({
            content: 'Se han actualizado las respuestas de manera correcta.',
            className: 'psychology-message'
          });
        } else {
          message.error({
            content: 'Ocurrió un error. Inténtalo de nuevo.',
            className: 'psychology-message'
          });
        }
        setDisabledButton(false)
        setNewQuestionAnswers([]);
        setLoading(false);
      } else {
        setLoading(false);
        message.error({
          content: 'Ocurrió un error. Inténtalo de nuevo.',
          className: 'psychology-message'
        });
      }
    } catch (error) {
      console.error(error);
      message.error({
        content: 'Ocurrió un error. Inténtalo de nuevo.',
        className: 'psychology-message'
      });
    }
    setLoading(false);
  }

  useEffect(() => {
    if (validateSite()) {
      if (!questionAnswers || questionAnswers.length === 0) {
        getQuestionsAnswers();
      }
    } else {
      message.error({
        content: 'No tiene los permisos.',
        className: 'psychology-message'
      });
    }
  }, [onEdit]);

  return (
    <Row justify="center">
      <Col lg={22} md={22}>
        {
          questionAnswers?.map((questionAnswer, index) => {
            return (
              <Row key={index} className="answer-gray-row">
                <Col md={22}>
                  <EditAnswer
                    answer={questionAnswer}
                    onEdit={onEdit}
                  />
                </Col>
              </Row>
            )
          })
        }
        {
          <Row justify="end" className="mb-40">
            <Col md={6}>
              <Button
                loading={loading}
                disabled={!disabledButton}
                className={!disabledButton ? 'button-disabled' : ''}
                type="primary"
                size="large"
                onClick={updateAnswer}
                block
              >
                Confirmar cambio
              </Button>
            </Col>
          </Row>
        }
      </Col>
    </Row>
  );
};

export default TestRevisionPage;